import _ from 'lodash';
import { comments } from '../bff.api';
import responseValidators from '../response.validators';

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const _commentUpdateBody = (data) => _.pick(data, ['text', 'mentions']);

const add = async (dossierId, data, options = {}) => {
  return comments
    .add(dossierId, _commentUpdateBody(data))
    .then((resp) => {
      responseValidators.addComment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (dossierId, commentId, data, options = {}) => {
  return comments
    .update(dossierId, commentId, _commentUpdateBody(data))
    .then((resp) => {
      responseValidators.updateComment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (dossierId, commentId, options = {}) => {
  return comments
    .delete(dossierId, commentId)
    .then((resp) => {
      responseValidators.deleteComment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const pin = async (dossierId, commentId, options = {}) => {
  return comments
    .pin(dossierId, commentId)
    .then((resp) => {
      responseValidators.pinComment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const unpin = async (dossierId, commentId, options = {}) => {
  return comments
    .unpin(dossierId, commentId)
    .then((resp) => {
      responseValidators.unpinComment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const commentsService = {
  add,
  update,
  remove,
  pin,
  unpin
};

export default commentsService;
